import { lazy } from "react"
import { ComponentsType } from "types/CommonsTypes"

const ManualTransition = lazy(() => import("components/Core/ProductTransition/ManualTransition"))

export const sodimac: ComponentsType = {
  ProductTransition: ManualTransition,
}
